// extracted by mini-css-extract-plugin
export default {"block":"Footer_block__DgWs0","text":"Footer_text__OgeoM","links":"Footer_links__UDcC6","link":"Footer_link__rAVkt"};